// extracted by mini-css-extract-plugin
module.exports = {"disabledPill":"styles_disabledPill__U7jm5"};